import { createSelector } from "reselect"

import { capitalise } from "../../happinessSurvey/components/Answer/Dropdown"

const rankingState = state => state.rankingsData

export const getCompanies = createSelector(rankingState, state => state.companies)

export const getCompaniesIsLoading = createSelector(rankingState, state => state.isCompaniesLoading)

export const getMoreCompaniesIsLoading = createSelector(rankingState, state => state.isMoreCompaniesLoading)

export const getCompaniesRankingOffset = createSelector(rankingState, state => state.offset)

export const getCompaniesRankingTotal = createSelector(rankingState, state => state.total)

export const getLoadFrom = createSelector(rankingState, state => state.loadFrom)

export const getRankings = createSelector(rankingState, state => state && state.rankings)

export const getIsLoading = createSelector(rankingState, state => state && state.isLoading)

export const getIsLoadingMore = createSelector(rankingState, state => state && state.isLoadingMore)

export const getHasLoadedAll = createSelector(rankingState, state => state && state.hasLoadedAll)

export const getCompanyRankings = createSelector(getRankings, rankings => rankings && rankings.company)

const formatCompanyRows = ({
  ranking,
  company,
  industry,
  country,
  recommendation,
  happinessScores,
  profile,
  companyNameKey,
  awardsBadges,
  year,
  filteredHappinessScores
}) => ({
  ranking,
  company,
  companyNameKey,
  industry: industry?.name,
  country: country?.name,
  recommendation: `${Math.round(recommendation * 100)}%`,
  happinessScore: Math.round(happinessScores?.score * 100),
  profile,
  awardsBadges,
  year,
  filteredHappinessScores
})

export const getCompanyTableRows = createSelector(getCompanyRankings, rankings =>
  rankings.map(rankingData => formatCompanyRows(rankingData))
)

export const getIsLoadingSurveyCompanies = createSelector(
  rankingState,
  rankings => rankings && rankings.isLoadingSurveyCompanies
)

const companiesSorted = companies => companies?.sort((a, b) => a.name.localeCompare(b.name))

export const getSurveyCompanies = createSelector(
  rankingState,
  rankings =>
    rankings?.surveyCompanies &&
    companiesSorted(rankings?.surveyCompanies.map(company => ({ id: company.id, name: company.companyName })))
)

export const getActiveFilters = createSelector(rankingState, state => state && state?.filters)

export const getFiltersAsChips = createSelector(getActiveFilters, filters => {
  const chipFilters = Object.entries(filters).reduce((acc, [key, value]) => {
    if (!value) return acc

    if (key === "demographicFilters") {
      Object.entries(value).forEach(([demoKey, demoValue]) => {
        acc[demoKey] = demoValue
      })
      return acc
    }

    acc[key] = {
      label: value.name,
      value: value.id
    }

    return acc
  }, {})

  return chipFilters
})

export const getWHWFilterData = createSelector(rankingState, state => state.whwFilters.data)

export const getMobileWHWFilterData = createSelector(getWHWFilterData, state => {
  return Object.entries(state).map(([key, arr]) => ({
    label: capitalise(key),
    type: "select",
    id: key,
    items: arr.map(({ id, name }) => ({
      label: name,
      value: id
    }))
  }))
})

export const getSearchTerm = createSelector(rankingState, state => state.searchTerm)
